import { ChangeDetectionStrategy, Component } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbColorPickerComponent } from 'libs/gb-dashboard/shared/ui/src/lib/gb-color-picker/gb-color-picker.component'
import { TranslateModule } from '@ngx-translate/core'
import { GbPresenterColorResolverService } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-color-resolver.service'

interface TestColorToken {
  token: string
  labelTranslateKey: string
  control: FormControl<string>
}

@Component({
  selector: 'gb-presenter-test-theme',
  imports: [GbDashboardSharedUiModule, GbColorPickerComponent, ReactiveFormsModule, TranslateModule],
  templateUrl: './gb-presenter-test-theme.component.html',
  styleUrl: './gb-presenter-test-theme.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterTestThemeComponent {
  constructor(private colorResolver: GbPresenterColorResolverService) {}

  readonly colorTokens: TestColorToken[] = [
    {
      token: 'primary_color',
      labelTranslateKey: 'PRESENTER.COLOR_TOKENS.PRIMARY_COLOR',
      control: new FormControl<string>('#FF7A6B', { nonNullable: true }),
    },
    {
      token: 'background_color',
      labelTranslateKey: 'PRESENTER.COLOR_TOKENS.BACKGROUND_COLOR',
      control: new FormControl<string>('#3AB4FF', { nonNullable: true }),
    },
    {
      token: 'accent_color',
      labelTranslateKey: 'PRESENTER.COLOR_TOKENS.ACCENT_COLOR',
      control: new FormControl<string>('#FFD700', { nonNullable: true }),
    },
    {
      token: 'banner_background_color',
      labelTranslateKey: 'PRESENTER.COLOR_TOKENS.BANNER_BACKGROUND_COLOR',
      control: new FormControl<string>('#39A065', { nonNullable: true }),
    },
    {
      token: 'warning_color',
      labelTranslateKey: 'PRESENTER.COLOR_TOKENS.WARNING_COLOR',
      control: new FormControl<string>('#F44336', { nonNullable: true }),
    },
    {
      token: 'success_color',
      labelTranslateKey: 'PRESENTER.COLOR_TOKENS.SUCCESS_COLOR',
      control: new FormControl<string>('#26C6DA', { nonNullable: true }),
    },
  ]

  onColorChange(token: string, value: string): void {
    this.colorResolver.updateTestColor(token, value)
  }
}
